import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ChangePasswordRequest } from '@shared/models/force-change-password.model';
import { Observable } from 'rxjs';

import { BaseService } from './base.service';

@Injectable({
  providedIn: 'root'
})
export class ChangePasswordService extends BaseService {
  public override headers: HttpHeaders;
  private userName: string;

  constructor(private readonly http: HttpClient) {
    super();
    this.envService = this.env.services.users;
    this.headers = new HttpHeaders(this.envService.headers);
  }

  public forceChangePassword(request: ChangePasswordRequest): Observable<any> {
    const url = this.getFullNestUrl(this.envService.forceChangePassword, {
      userName: request.userName
    });

    return this.http.post<any>(
      url,
      { newPassword: request.newPassword },
      {
        headers: this.headers,
        observe: 'response'
      }
    );

    // return of({
    //   status: 200,
    //   statusText: ''
    // })

    // return throwError(() => {
    //   return { error: { code: '02002', message: '', translateKey: '' } };
    // });
  }
}
